module.exports = __webpack_public_path__ + "img/suger_bs.ae1a5b53.png";